<template>
  <div class="app-wrapper">
    <el-container class="app-box">
      <el-aside
        :width="asideShow ? '240px' : '0px'"
        class="main-aside"
        :style="themeColor[themeIndex].aside"
        v-show="ShowModel"
      >
        <sidebar class="sidebar-container"></sidebar>
      </el-aside>
      <el-container class="main">
        <el-header
          class="heads"
          height="50px"
          :style="themeColor[themeIndex].header"
          v-show="ShowModel">
          <Headers
            :asideShow.sync="asideShow"
            @targetIcon="targetIcon"
            :themeColor="themeColor"
            :themeIndex="themeIndex"
            @targetThemeIndex="targetThemeIndex"
          ></Headers>
        </el-header>
        <el-main class="main-container">
<!--          <TagsViews v-show="ShowModel" />-->
          <div class="main-container-views" >
            <transition name="nodebook" mode="out-in">
                <router-view />
            </transition>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <el-backtop target=".main-container-views" :bottom="100">
      <div class="scrollTop">
        <i class="el-icon-upload2"></i>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import Sidebar from "../components/Sidebar/index.vue";
import Headers from "../components/Headers/Headers.vue";
import TagsViews from "../components/TageView/TagsView.vue";

// 获取本地存储的主题
import { getTheme, setTheme } from "@/utils/theme";
let Theme = parseInt(getTheme()) || 0;

let themeColor = [
  {
    aside: "background-image: linear-gradient(#3271e2, #3271e2);",
    header: "background-image: linear-gradient(to right,#3271e2, #3271e2);",
    container:
      "background-image: linear-gradient(to bottom right,#f1f1f1,#f1f1f1);",
  },

];
export default {
  data() {
    return {
      asideShow: true,
      themeIndex: Theme, //当前配色方案
      themeColor: themeColor, //配色方案
      ShowModel: true, //展示模式
      temp: {},
    };
  },
  components: {
    Sidebar,
    Headers,
    // TagsViews,
  },
  methods: {
    targetIcon(boole) {
      this.asideShow = boole;
    },
    // 配色方案 子元素自定义事件
    targetThemeIndex(index) {
      this.themeIndex = index;
      setTheme(index);
    },
    IsCef() {
      // if (BaseDataHanle.hospital.iD) {
      //   this.temp = BaseDataHanle;
      //   this.ShowModel = false;
      // }
    },
  },
  mounted() {
    this.IsCef();
  },
};
</script>

<style>

</style>
